import { render, staticRenderFns } from "./OverviewIndex.vue?vue&type=template&id=dda78f54&scoped=true"
import script from "./OverviewIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OverviewIndex.vue?vue&type=style&index=0&id=dda78f54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda78f54",
  null
  
)

export default component.exports